// modules
import * as R from 'ramda'
// actions
import {
  QUEUE_PUSH,
  QUEUE_REMOVE_UNSAVED,
  QUEUE_EMPTY,
  QUEUE_ACK,
  QUEUE_RETRY_DEC,
} from './queue.action'

const initialState = {
  seqId: 2,
  queue: [],
}

// lens
const queueLens = R.lensProp('queue')

// reducers
const reducers = {
  [QUEUE_PUSH]: ({ seqId, queue }, payload) => ({
    seqId: seqId + 1,
    queue: [...queue, R.assocPath(['data', 'meta', 'seqId'], seqId, payload)],
  }),

  [QUEUE_REMOVE_UNSAVED]: R.over(queueLens, R.filter(R.prop('save'))),

  [QUEUE_RETRY_DEC]: R.over(
    queueLens,
    R.compose(
      R.map(msg => ({ ...msg, retry: msg.retry - 1 })),
      R.filter(R.prop('retry')),
    ),
  ),

  [QUEUE_ACK]: ({ seqId, queue }, ack) => ({
    seqId: ack > seqId ? ack : seqId,
    queue: R.filter(
      item => R.path(['data', 'meta', 'seqId'], item) > ack,
      queue,
    ),
  }),

  [QUEUE_EMPTY]: R.set(queueLens, []),
}

export default function reducer(state = initialState, { type, payload }) {
  return reducers[type] ? reducers[type](state, payload) : state
}
